export { default } from './Alert';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Alert/index.js
// module id = 873
// module chunks = 0